import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../components/LoginPage.vue'
import MockupView from '../components/MockupView.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/mockup/:projectId',
    name: 'Mockup',
    component: MockupView,
    props: true,
    beforeEnter: (to, from, next) => {
      // Check if user has access granted
      const accessGranted = sessionStorage.getItem('accessGranted')
      const projectId = sessionStorage.getItem('projectId')
      
      console.log('Route guard - accessGranted:', accessGranted)
      console.log('Route guard - projectId:', projectId)
      console.log('Route guard - to.params.projectId:', to.params.projectId)
      
      if (accessGranted === 'true') {
        // Verify the projectId matches if stored
        if (projectId && to.params.projectId !== projectId) {
          console.warn('Project ID mismatch, but allowing access')
        }
        next()
      } else {
        console.log('Access not granted, redirecting to login')
        next('/')
      }
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

